export const GET_USER_WALLETS_START = 'GET_USER_WALLETS_START';
export const GET_USER_WALLETS_SUCCESS = 'GET_USER_WALLETS_SUCCESS';
export const GET_USER_WALLETS_ERROR = 'GET_USER_WALLETS_ERROR';
